/**
 * Returns the mailboxEmail query parameter string to append to Outlook API URLs.
 * If activeMailbox is null or empty (personal), returns empty string.
 * If the URL already has query params (contains '?'), returns '&mailboxEmail=...'
 * Otherwise returns '?mailboxEmail=...'
 */
export const getMailboxParam = (
  activeMailbox: string | null,
  existingUrl: string,
): string => {
  if (!activeMailbox) return "";
  const separator = existingUrl.includes("?") ? "&" : "?";
  return `${separator}mailboxEmail=${encodeURIComponent(activeMailbox)}`;
};
